import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function AdminResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(token ? "" : "Link di recupero non valido.");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Le password non coincidono.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setSuccess(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "Reimpostazione non riuscita."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-void px-6" data-testid="admin-reset-password-page">
      <div className="w-full max-w-sm border border-line bg-surface p-10">
        <div className="flex justify-center">
          <img src="/media/logo-full.png" alt="Logo Orologi e Preziosi" className="h-24 w-24 object-contain" data-testid="admin-logo-image" />
        </div>
        <p className="mt-2 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-muted">Nuova Password</p>

        {success ? (
          <div className="mt-10 text-center" data-testid="admin-reset-success">
            <p className="font-serif text-2xl italic text-gold">Password aggiornata.</p>
            <p className="mt-4 text-sm font-light leading-relaxed text-muted">Ora puoi accedere con la nuova password.</p>
            <Link to="/admin" data-testid="admin-reset-login-link" className="mt-8 inline-block border border-gold px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] text-gold transition-colors duration-500 hover:bg-gold hover:text-void">
              Vai al login
            </Link>
          </div>
        ) : !token ? (
          <div className="mt-10 text-center" data-testid="admin-reset-invalid">
            <p className="font-serif text-2xl italic text-red-400">Link non valido.</p>
            <p className="mt-4 text-sm font-light leading-relaxed text-muted">Richiedi un nuovo link di recupero dalla pagina di accesso.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-10 space-y-5">
            <div>
              <label className="mb-2 block font-mono text-[10px] uppercase tracking-[0.25em] text-muted">Nuova password</label>
              <input
                type="password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-new-password-input"
                className="w-full border border-line bg-transparent px-4 py-3 text-sm text-ivory outline-none transition-colors duration-300 focus:border-gold"
                autoComplete="new-password"
              />
            </div>
            <div>
              <label className="mb-2 block font-mono text-[10px] uppercase tracking-[0.25em] text-muted">Conferma password</label>
              <input
                type="password"
                required
                minLength={8}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                data-testid="admin-confirm-password-input"
                className="w-full border border-line bg-transparent px-4 py-3 text-sm text-ivory outline-none transition-colors duration-300 focus:border-gold"
                autoComplete="new-password"
              />
            </div>
            {error && <p data-testid="admin-reset-error" className="text-xs text-red-400">{error}</p>}
            <button
              type="submit"
              disabled={loading || !token}
              data-testid="admin-reset-submit"
              className="w-full border border-gold px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] text-gold transition-colors duration-500 hover:bg-gold hover:text-void disabled:cursor-not-allowed disabled:border-line disabled:text-muted disabled:hover:bg-transparent"
            >
              {loading ? "Aggiornamento…" : "Reimposta password"}
            </button>
          </form>
        )}

        {!success && (
          <Link to="/admin" data-testid="admin-reset-back" className="mt-8 block text-center font-mono text-[10px] uppercase tracking-[0.25em] text-muted transition-colors duration-300 hover:text-gold">
            ← Torna al login
          </Link>
        )}
      </div>
    </div>
  );
}
